import React, { Component } from 'react'
import { isMobile } from 'react-device-detect'
import { ResponsiveContext } from 'grommet'
import loadable from '@loadable/component'
import Measure from 'react-measure'
import { connect } from 'react-redux'
import Layout from '../../layout/GeneralLayout'
import {
  showTurntable,
  setTurntableSize,
  setChoices,
  setResultSelected,
} from '../../redux/rdg/actions'
import Turntable from '../../component/Turntable'
import Footer from '../../component/Footer'
import RDGInputs from '../../component/ReactRDG'
import RDGSharedImage from '../../images/tools/Date-Picker-Wheel.png'
import SEO from '../../component/SEO'
import PageTitle from '../../component/PageComponent/PageTitle'
import withWheelToolHOC from '../../component/HOC/withWheelToolHOC'
import FullScreenButton from '../../component/Button/FullScreenButton'
import {
  TurntableBox,
  BGContainer,
  ContainerTool,
  WheelWhiteBox,
  WheelBox,
  WheelPlaceholder,
} from '../../component/PageComponent/Box'
import { RelativeBox } from '../../component/Common'
import InputBox from '../../component/PageComponent/InputBox'
import AllResultsButton from '../../component/Button/AllResultsButton'
import ArticleContent from '../../component/Section/Content'
import SpinnerFullScreen from '../../component/Spinner/SpinnerFullScreen'
import BackgroundAllResults from '../../component/AllResults/BackgroundAllResults'
import ToolSettings from '../../component/ToolSettings'
import Versioning from '../../component/PageComponent/Versioning'
import MiddleBox from '../../component/PageComponent/MiddleBox'
import VolumeButton from '../../component/Button/VolumeButton'
import UnhideInputButton from '../../component/Button/UnhideInputButton'
// import FloatingTitle from '../../component/Title/FloatingTitle'
// import FloatingBox from '../../component/PageComponent/FloatingBox'
import withProvider from '../../component/HOC/withProvider'
import InputShield from '../../component/PageComponent/InputShield'
import ShareModeButton from '../../component/Button/ShareModeButton'
import SpinQuantity from '../../component/PageComponent/SpinQuantity'
import { replaceCDN } from '../../utils'
import { fontSizes } from '../../component/ReactTurntable/TurntableFontSize'
import moment from 'moment'
import FullScreenLayout from '../../layout/FullScreenLayout'

const inputOptions = [
  {
    name: '10/30/2022',
    format: 'MM/DD/YYYY',
    value: 0,
  },
  {
    name: '10-30-2022',
    format: 'MM-DD-YYYY',
    value: 1,
  },
  {
    name: 'October 30, 2022',
    format: 'MMMM D, YYYY',
    value: 2,
  },
  {
    name: 'Sunday, October 30, 2022',
    format: 'dddd, MMMM D, YYYY',
    value: 3,
  },
  {
    name: '30/10/2022',
    format: 'DD/MM/YYYY',
    value: 4,
  },
  {
    name: '30-10-2022',
    format: 'DD-MM-YYYY',
    value: 5,
  },
  {
    name: '30 October 2022',
    format: 'DD MMMM YYYY',
    value: 6,
  },
  {
    name: 'Sunday, 30 October 2022',
    format: 'dddd, DD MMMM YYYY',
    value: 7,
  },
]

const Modal = loadable(() =>
  import('../../component/Modals/ResultModal/RDGResultModal'),
)
const AllResults = loadable(() => import('../../component/AllResults'), {
  fallback: (
    <BackgroundAllResults justify="center">Loading...</BackgroundAllResults>
  ),
})

const ModifyTitleModal = loadable(
  () => import('../../component/Modals/ModifyTitleModal'),
  {
    fallback: <SpinnerFullScreen caption="Please wait..." />,
  },
)

const mapState = state => ({
  resultSelected: state.rdg.resultSelected,
  choices: state.rdg.choices,
  turnTable: state.rdg.turnTable,
  turnTableSize: state.rdg.turnTableSize,
  inputMode: state.rdg.inputMode,
  bgColor: state.settings.bgColor.color,
  spinQuantity: state.settings.spinBehavior.spinQuantity,
  bgImage: state.settings.bgImage,
  modifyTitleModal: state.modal.modifyTitleModal,
  inputs: state.rdg.inputs,
})

const actions = {
  setChoices,
  showTurntable,
  setTurntableSize,
  setResultSelected,
}

class RandomDateGenerator extends Component {
  state = {
    turntableBoxSize: 300,
    bgColor: 'var(--bgPlaceholder)',
    allResultsOpen: false,
    modalPreloaded: false,
    bgImage: { on: false, src: null },
    spinQuantityEnabled: false,
  }

  checkIsBlankWheel = () => {
    return !(
      this.props.inputs.length === 0 ||
      (this.props.inputs.length > 0 && this.props.choices.length > 0)
    )
  }

  convertChoices = () => {
    if (this.props.choices.length === 0) {
      let tempInputMode = this.props.inputMode
      const dateFormat = inputOptions.filter(
        input => input.value === tempInputMode,
      )[0].format
      // Set rdg initial wheel value to 8 dates starting from today based on the date format, instead of blank wheel initially
      const dates = []
      for (let i = 0; i < 8; i++) {
        const date = moment().add(i, 'days').format(dateFormat)
        dates.push(date)
      }

      return dates
    }
    return this.props.choices
  }

  componentDidMount() {
    this.setState({
      bgColor: this.props.bgColor,
      turntableBoxSize: this.props.turnTableSize,
      bgImage: this.props.bgImage,
      spinQuantityEnabled: this.props.spinQuantity,
    })
    const isBlankWheel = this.checkIsBlankWheel()
    const choices = this.convertChoices()
    const turnTable = (
      <Turntable
        page="rdg"
        choices={choices}
        size={this.props.turnTableSize}
        completed={choice => this.props.setResultSelected(choice)}
        gaEvent={{ category: 'RDG Actions', action: 'Spin Date Wheel' }}
        started={() => {
          if (!this.state.modalPreloaded) {
            Modal.preload()
            this.setState({ modalPreloaded: true })
          }
        }}
        fontSize={fontSizes.rdg.normal}
        isBlankWheel={isBlankWheel}
      />
    )
    this.props.showTurntable(turnTable)
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.bgColor !== this.props.bgColor) {
      this.setState({ bgColor: this.props.bgColor })
    }
    if (prevState.bgImage !== this.props.bgImage) {
      this.setState({ bgImage: this.props.bgImage })
    }
    if (prevState.spinQuantityEnabled !== this.props.spinQuantity) {
      this.setState({ spinQuantityEnabled: this.props.spinQuantity })
    }
    if (
      this.props.turnTableSize !== prevProps.turnTableSize &&
      this.props.turnTable !== null // only happen on initial render without local storage
    ) {
      this.props.showTurntable(null)
    }
    if (this.props.turnTable === null) {
      const isBlankWheel = this.checkIsBlankWheel()
      const choices = this.convertChoices()
      if (this.props.turnTableSize !== prevProps.turnTableSize) {
        this.setState({ turntableBoxSize: this.props.turnTableSize })
      }
      let fontSize = fontSizes.rdg.normal
      if (this.props.handleFullScreen.active) fontSize += fontSizes.rdg.extra
      const turnTable = (
        <Turntable
          page="rdg"
          choices={choices}
          size={this.props.turnTableSize}
          completed={choice => this.props.setResultSelected(choice)}
          gaEvent={{ category: 'RDG Actions', action: 'Spin Date Wheel' }}
          started={() => {
            if (!this.state.modalPreloaded) {
              Modal.preload()
              this.setState({ modalPreloaded: true })
            }
          }}
          fontSize={fontSize}
          fullScreenActive={this.props.handleFullScreen.active}
          isBlankWheel={isBlankWheel}
        />
      )
      this.props.showTurntable(turnTable)
    }
  }

  render() {
    const {
      resultSelected,
      turnTable,
      setTurntableSize,
      showTurntable,
      getShareLoading,
      handleFullScreen,
      handleHideInput,
      modifyTitleModal,
    } = this.props
    const {
      bgColor,
      turntableBoxSize,
      allResultsOpen,
      bgImage,
      spinQuantityEnabled,
    } = this.state
    return (
      <Layout>
        <ResponsiveContext.Consumer>
          {size => {
            return (
              <>
                {getShareLoading && (
                  <SpinnerFullScreen caption="Getting share data..." />
                )}
                <BGContainer
                  alignSelf="stretch"
                  justify="center"
                  align="stretch"
                  bgColor={bgColor}
                >
                  <FullScreenLayout handle={handleFullScreen}>
                    {resultSelected && <Modal result={resultSelected} />}
                    {modifyTitleModal && (
                      <ModifyTitleModal
                        page="rdg"
                        phTitle="Date Picker Wheel"
                        phDescription="Pick a random date by wheel"
                      />
                    )}
                    <PageTitle
                      page="rdg"
                      title="Date Picker Wheel"
                      caption="Pick a random date by wheel"
                      fullScreenActive={handleFullScreen.active}
                      bgColor={bgColor}
                    />
                    <ContainerTool
                      fullScreenActive={handleFullScreen.active}
                      style={{ zIndex: 2 }}
                    >
                      <WheelWhiteBox
                        background="baseBackground"
                        align="center"
                        fullScreenActive={handleFullScreen.active}
                        bgImage={!bgImage.on ? null : replaceCDN(bgImage.src)}
                        // round="2rem"
                      >
                        <WheelBox
                          // width="120rem"
                          direction="row"
                          wrap={true}
                          justify="center"
                          fullScreenActive={handleFullScreen.active}
                        >
                          {typeof window === 'undefined' ? ( // for ssr rendering
                            <TurntableBox
                              alignSelf="center"
                              align="center"
                              justify="center"
                              flex="grow"
                              // minHeight="300px"
                            >
                              <WheelPlaceholder size={600} />
                              <Turntable page="rdg" choices={[]} size={300} />
                            </TurntableBox>
                          ) : (
                            <Measure
                              bounds
                              onResize={contentRect => {
                                const width = contentRect.bounds.width
                                const maxWidth = handleFullScreen.active
                                  ? 1200
                                  : 600
                                if (width > maxWidth) {
                                  if (turntableBoxSize !== maxWidth) {
                                    setTurntableSize(maxWidth)
                                  }
                                } else if (width !== 0) {
                                  setTurntableSize(width)
                                } else if (width === 0) {
                                  const tempWidth = isMobile ? 300 : maxWidth
                                  setTurntableSize(tempWidth)
                                  showTurntable(null)
                                }
                              }}
                            >
                              {({ measureRef }) => (
                                <TurntableBox
                                  ref={measureRef}
                                  alignSelf="center"
                                  align="center"
                                  justify="center"
                                  flex="grow"
                                  fullScreenActive={handleFullScreen.active}
                                  minHeight={
                                    turntableBoxSize
                                      ? `${turntableBoxSize}px`
                                      : '300px'
                                  }
                                >
                                  <WheelPlaceholder size={turntableBoxSize} />
                                  {turnTable}
                                  {allResultsOpen && (
                                    <AllResults
                                      page="rdg"
                                      fullScreenActive={handleFullScreen.active}
                                      close={() =>
                                        this.setState({
                                          allResultsOpen: false,
                                        })
                                      }
                                    />
                                  )}
                                  {spinQuantityEnabled && <SpinQuantity />}
                                </TurntableBox>
                              )}
                            </Measure>
                          )}
                          <InputBox
                            align="center"
                            justify="center"
                            flex="shrink"
                            fullScreenActive={handleFullScreen.active}
                          >
                            {/* <ToolTitle page="rdg" /> */}
                            <RelativeBox>
                              <RDGInputs inputOptions={inputOptions} />
                              {handleHideInput.showShield && (
                                <InputShield page="rdg" />
                              )}
                            </RelativeBox>
                          </InputBox>
                        </WheelBox>
                        {/* <FloatingBox fullScreenActive={handleFullScreen.active}>
                          <FloatingTitle
                            page="rdg"
                            fullScreenActive={handleFullScreen.active}
                          />
                        </FloatingBox> */}

                        {!handleFullScreen.active &&
                          !handleHideInput.shareModeActive && (
                            <UnhideInputButton />
                          )}
                        {/* hiding logic used inside component for animation */}
                        {!handleFullScreen.active &&
                          handleHideInput.hiding &&
                          handleHideInput.shareModeActive && (
                            <ShareModeButton page="rdg" />
                          )}
                        <VolumeButton />
                        <AllResultsButton
                          openBox={() => {
                            this.setState({ allResultsOpen: !allResultsOpen })
                          }}
                          isOpened={allResultsOpen}
                        />
                        <FullScreenButton handleFullScreen={handleFullScreen} />
                      </WheelWhiteBox>
                    </ContainerTool>
                  </FullScreenLayout>
                  <ContainerTool
                    fullScreenActive={false}
                    id="ToolSettingsSection"
                  >
                    <MiddleBox />
                    <ToolSettings size={size} page="rdg"></ToolSettings>
                    <Versioning size={size} />
                  </ContainerTool>
                </BGContainer>

                <ArticleContent content="RDGManual" />
                <Footer />
              </>
            )
          }}
        </ResponsiveContext.Consumer>
      </Layout>
    )
  }
}

export default connect(
  mapState,
  actions,
)(withProvider(withWheelToolHOC(RandomDateGenerator, 'rdg')))

export const Head = () => (
  <SEO
    keywords={[
      'random date generator',
      'date picker wheel',
      'random day generator',
      'date generator',
      'random date',
      'random date picker',
      'pick a random date',
    ]}
    title="Date Picker Wheel - Generate Random Date by Spinning"
    description="Date Picker Wheel is a specialized random date generator that picks a random date from any day by spinning wheel. There are many functions and customizations."
    tool
    pathname="/tools/random-date-generator/"
    image={RDGSharedImage}
  />
)
